<template>
    <div>
        <div class="empty flex-column-center">
            <div class="empty-img">
                <img src="@/assets/list.png" :style="{ width: size + 'px', height: size + 'px' }" alt="">
            </div>
            <div class="empty-title">{{ text }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        text: {
            type: String,
            default: '暂无数据'
        },
        size: {
            type: [String, Number],
            default: 160
        }
    }
}
</script>
<style>
.empty-title {
    font-size: 14px;
    color: #999;
}
</style>